import { FeedbackWithDetails } from '@/common/types/databaseTypes';
import { Box, Center, Flex, Loader, Text } from '@mantine/core';
import { FeedbackCard } from '../utils/FeedbackCardRenderers';
import { useTranslation } from 'react-i18next';

interface ReceivedFeedbackTabProps {
    receivedFeedbacks: FeedbackWithDetails[] | undefined;
    isLoadingReceived: boolean;
}

/**
 * 받은 피드백 탭 컴포넌트
 */
const ReceivedFeedbackTab = ({
    receivedFeedbacks,
    isLoadingReceived,
}: ReceivedFeedbackTabProps) => {
    const { t } = useTranslation(['feedback']);

    return (
        <>
            {isLoadingReceived ? (
                <Flex justify="center" align="center" h={200}>
                    <Loader />
                </Flex>
            ) : receivedFeedbacks && receivedFeedbacks.length > 0 ? (
                <Box
                    flex={1}
                    className="custom-scrollbar"
                    pr={16}
                    mr={16}
                    style={{
                        overflowY: 'auto',
                    }}
                >
                    {receivedFeedbacks.map(feedback => (
                        <FeedbackCard
                            key={feedback.id}
                            feedback={feedback}
                            isReceived={true}
                        />
                    ))}
                </Box>
            ) : (
                <Center h="100%" py="xl" ta="center">
                    <Text c="dimmed" mt="md">
                        {t('placeHolder.received')}
                    </Text>
                </Center>
            )}
        </>
    );
};

export default ReceivedFeedbackTab;
